import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DarwinButton } from 'components/darwin-ui';
import Icon from 'components/darwin-ui/Icon';
import { useUI } from 'contexts/UiContext';
import { useFloatNotification } from 'contexts/FloatNotificationContext';
import { downloadTemplate } from 'api/services/massiveTransactionsService';
import styles from './index.module.css';
import { ProcessBlockData } from 'types/processBlockTypes';
import { ErrorType } from 'types/genericTypes';

export const DownloadTemplate = ({
  processBlock,
}: {
  processBlock?: ProcessBlockData;
}) => {
  const { t } = useTranslation();
  const { selectedCompany } = useUI();
  const { openNotification } = useFloatNotification();
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownload = async () => {
    if (!selectedCompany || !processBlock) {
      openNotification(t('error'), t('error'), 'error');
      return;
    }

    setIsDownloading(true);
    try {
      await downloadTemplate(
        selectedCompany,
        processBlock.id,
        processBlock.name || ''
      );
      openNotification(
        t('success'),
        t('process-flow.data-capture.download-template.success'),
        'success'
      );
    } catch (err) {
      const apiError = err as ErrorType;
      if (apiError.body?.errorCode) {
        openNotification(t('error'), t(apiError.body.errorCode), 'error');
      } else {
        openNotification(
          t('error'),
          t('process-flow.data-capture.download-template.error'),
          'error'
        );
      }
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <DarwinButton
      type="default"
      icon={<Icon name="download-file" size="lg" color="white" />}
      className={styles.downloadButton}
      onClick={handleDownload}
      disabled={isDownloading}
      loading={isDownloading}
    >
      {isDownloading
        ? t('process-flow.data-capture.download-template.downloading')
        : t('process-flow.data-capture.download-template.label')}
    </DarwinButton>
  );
};
